import { render } from "./Hinnakiri.vue?vue&type=template&id=5a66e23c"
import script from "./Hinnakiri.vue?vue&type=script&lang=js"
export * from "./Hinnakiri.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__